import React, { useState } from 'react'
import { useEffect } from 'react'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import { Box } from '@mui/system'
import { callAddFontRobotoBold } from "../../../common/font/Roboto-bold"
import { callAddFontRobotoMedium } from "../../../common/font/Roboto-Medium-normal"
import { Button, Stack,Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useTheme } from '@mui/material'
import { Item } from '../../../common/snippets'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import { useSelector } from 'react-redux'
import { colors, excelHeader1, excelHeader2, jsPdfHeaderFooter, pdfHeaderColumn1, pdfHeaderColumn2, paymentWiseColumns, paymentWiseColumnsStyles, paymentWiseDrawCell } from './constants'
import { PaymentWiseLargePdf } from './LargePDF'
import moment from 'moment'
import * as id from '../reportId'
import { focusElemnt, navigation3 } from '../../../common/helper'
const PaymentTypeAndSourceTable = (props) => {
    const { headerData, tableData, disableExcel,loginCountryId} = props
    const theme = useTheme()
    const { tableHeaderColor } = theme
    const { loginData } = useSelector(state => state?.common)
    const [showTableData, setShowTableData] = useState([])
    const [searchResult, setSearchResult] = useState(true)
    const [largePDF, setLargePDF] = useState(false)
    const [state, setState] = useState({
        generatePDF: false,
        load: false,
    })
    const { generatePDF, load, } = { ...state }
    const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm');

    useEffect(() => {
        if (tableData?.length > 0) {
            setShowTableData(tableData)
        } else {
            setShowTableData([])
        }
    }, [tableData])

    const printClick = (isSave) => {
        setState({ ...state, load: true, generatePDF: true })
        jsPDF.API.events.push(["addFonts", callAddFontRobotoBold]);
        jsPDF.API.events.push(["addFonts", callAddFontRobotoMedium]);

        // const pdfColumns = paymentWiseColumns.map((col) => {
        //     return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
        // })
        const filteredColumns = paymentWiseColumns.filter(col => {
            return !(loginCountryId === 2 && col.field === 'ServiceTaxAmount');
        });
        const pdfColumns = filteredColumns.map((col) => {
            return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol };
        });
        const HeaderColumns1 = pdfHeaderColumn1.map((col) => {
            return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
        })
        const HeaderColumns2 = pdfHeaderColumn2.map((col) => {
            return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
        })
        const doc = new jsPDF({ orientation: 'p', format: [1080, 1528], unit: 'px',compress:true })
        var totalPagesExp = '{total_pages_count_string}'
        doc.setProperties({
            title: `Received Reports.pdf`,
            subject: 'Received  Report',
            author: 'Maven Tech Labs Pvt. Ltd.',
            keywords: 'maven tech, Cargo system, Receive',
            creator: 'MTLPL',
        })

        autoTable(doc, {
            margin: { top: 60, left: 30, right: 30, bottom: 5 },
            alternateRowStyles: {
                fillColor: [255, 255, 255],
            },
            columns: HeaderColumns1,
            body: [headerData],
            columnStyles: {
                0: { fontSize: 18, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
                1: { fontSize: 18, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
                2: { fontSize: 18, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
                3: { fontSize: 18, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
                4: { fontSize: 18, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
                5: { fontSize: 18, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
                6: { fontSize: 18, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
            },
            theme: 'grid',
            startY: 160,
            headStyles: {
                fillColor: [191, 225, 255],
                textColor: [0, 0, 0],
                minCellHeight: 36,
                valign: 'middle',
                cellPadding: 12,
                fontSize: 18,
                font: 'Roboto',
                fontStyle: 'normal',
                lineWidth: 0.6,
            },
            didDrawPage: function (data) {
                doc.setTextColor(0, 0, 0)
                doc.setFontSize(18).setFont('Roboto', 'bold')
                doc.text(`Received Date : ${moment(headerData.fromDate).format('DD-MMM-YYYY')}  To  ${moment(headerData.toDate).format('DD-MMM-YYYY')}`, data.settings.margin.left, 150)
                doc.text(`Report View: Summary`, doc.internal.pageSize.width - data.settings.margin.left, 150, "right")
            },
        })

        autoTable(doc, {
            margin: { top: 120, left: 30, right: 30, bottom: 5 },
            alternateRowStyles: {
                fillColor: [255, 255, 255],
            },
            columns: HeaderColumns2,
            body: [headerData],
            columnStyles: {
                0: { fontSize: 18, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
                1: { fontSize: 18, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
                2: { fontSize: 18, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
                3: { fontSize: 18, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
                4: { fontSize: 18, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
                5: { fontSize: 18, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
            },
            theme: 'grid',
            startY: 240,
            headStyles: {
                fillColor: [191, 225, 255],
                textColor: [0, 0, 0],
                minCellHeight: 36,
                valign: 'middle',
                cellPadding: 12,
                fontSize: 18,
                font: 'Roboto',
                fontStyle: 'normal',
                lineWidth: 0.6,
            },
        })
        
        autoTable(doc, {
            margin: { top: 180, left: 30, right: 30, bottom: 40 },
            alternateRowStyles: {
                fillColor: [255, 255, 255],
            },
            headStyles: {
                fillColor: [191, 225, 255],
                fontSize: 16,
                minCellHeight: 36,
                cellPadding: 6,
                valign: 'middle',
                fontStyle: 'normal',
                font: 'Roboto',
                textColor:[0,0,0]
            },
            tableLineWidth: 0.6,
            columns: pdfColumns,
            body: showTableData,
            styles: {
                lineWidth: [0, 0.2, 0, 0.2]
            },
            columnStyles: paymentWiseColumnsStyles,
            theme: 'grid',
            showHead:"never",
            didParseCell: (data) => {
                paymentWiseDrawCell(data,loginCountryId)
            },
            didDrawPage: function (data) {
                doc.setTextColor(40)
                doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
                doc.setFontSize(26).setFont("Roboto", 'bold')
                doc.setTextColor(16, 79, 162)
                doc.text('Cargo System | Received Report', 30 + 60, 80)
                doc.setTextColor(0, 0, 0)
                doc.setFontSize(22).setFont("Roboto", 'bold')
                doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, "right")
                jsPdfHeaderFooter(data, loginData, totalPagesExp)
            },
        })
        doc.setFont('Roboto')

        if (typeof doc.putTotalPages === 'function') {
            doc.putTotalPages(totalPagesExp)
        }
        if (isSave) {
            doc.save(`Receive Reports ${currentDateTime}.pdf`)
            setTimeout(() => {
                setState({ ...state, generatePDF: false, load: true })
                const pdfUrl = doc.output('bloburl')
                document.getElementById('recvedPaymentWiseOutput').data = pdfUrl
                // document.getElementById('recvedPaymentWiseOutput').data = doc.output('datauristring', ' Receive Reports.pdf')
                focusElemnt("backBtn")
            }, 2000)
        } else {
            setTimeout(() => {
                setState({ ...state, generatePDF: false, load: true })
                const pdfUrl = doc.output('bloburl')
                document.getElementById('recvedPaymentWiseOutput').data = pdfUrl
                // document.getElementById('recvedPaymentWiseOutput').data = doc.output('datauristring', ' Receive Reports.pdf')
                focusElemnt("backBtn")
            }, 2000)
        }
    }

    const InsideRowContent = ({ item, index }) => {
        return (
            <TableRow className="receivedTr" key={index}>
                {
                    item?.isHeading ?
                        <>
                            <TableCell className="userWiseReportHeading" key={index} style={{ color: tableHeaderColor.textColor, backgroundColor: tableHeaderColor?.isHeadingColor, position: "sticky", top: "-5px" }} colSpan={3}>{item?.SN}</TableCell>
                            <TableCell className="userWiseReportHeading" key={index} style={{ textAlign: "right", color: tableHeaderColor.textColor, backgroundColor: tableHeaderColor?.isHeadingColor, position: "sticky", top: "-5px" }} colSpan={2}>{item?.CartageAmt}</TableCell>
                            <TableCell className="userWiseReportHeading" style={{ textAlign: "right", color: tableHeaderColor.textColor, backgroundColor: tableHeaderColor?.isHeadingColor, position: "sticky", top: "-5px" }} colSpan={loginCountryId===2?4:5}>{item?.Valuation} </TableCell>
                            {/* <TableCell className="userWiseReportHeading" style={{  color: tableHeaderColor.textColor, backgroundColor: tableHeaderColor?.isHeadingColor, position: "sticky", top: "-5px" }} colSpan={1}></TableCell> */}
                        </> :
                        item?.isSubHeading ?
                            <>
                                <TableCell className="userWiseReportSubHeading" style={{ backgroundColor: tableHeaderColor?.isSubHeadingColor, fontWeight: 700, color: tableHeaderColor.textColor, textAlign: "center", position: "sticky", top: "30px" }} colSpan={1}>{item?.SN}</TableCell>
                                <TableCell className="userWiseReportSubHeading" style={{ backgroundColor: tableHeaderColor?.isSubHeadingColor, fontWeight: 700, color: tableHeaderColor.textColor, position: "sticky", top: "30px" }} colSpan={1}>{item?.PaymentType}</TableCell>
                                <TableCell className="userWiseReportSubHeading" style={{ backgroundColor: tableHeaderColor?.isSubHeadingColor, fontWeight: 700, color: tableHeaderColor.textColor, textAlign: "right", position: "sticky", top: "30px" }} colSpan={1}>{item?.NOP}</TableCell>
                                <TableCell className="userWiseReportSubHeading" style={{ backgroundColor: tableHeaderColor?.isSubHeadingColor, fontWeight: 700, color: tableHeaderColor.textColor, textAlign: "right", position: "sticky", top: "30px" }} colSpan={1}>{item?.Freight}</TableCell>
                                <TableCell className="userWiseReportSubHeading" style={{ backgroundColor: tableHeaderColor?.isSubHeadingColor, fontWeight: 700, color: tableHeaderColor.textColor, textAlign: "right", position: "sticky", top: "30px" }} colSpan={1}>{item?.CartageAmt}</TableCell>
                                <TableCell className="userWiseReportSubHeading" style={{ backgroundColor: tableHeaderColor?.isSubHeadingColor, fontWeight: 700, color: tableHeaderColor.textColor, textAlign: "right", position: "sticky", top: "30px" }} colSpan={1}>{item?.HamaliChgs}</TableCell>
                                <TableCell className="userWiseReportSubHeading" style={{ backgroundColor: tableHeaderColor?.isSubHeadingColor, fontWeight: 700, color: tableHeaderColor.textColor, textAlign: "right", position: "sticky", top: "30px" }} colSpan={1}>{item?.OtherChgs}</TableCell>
                                {loginCountryId!==2&&<TableCell className="userWiseReportSubHeading" style={{ backgroundColor: tableHeaderColor?.isSubHeadingColor, fontWeight: 700, color: tableHeaderColor.textColor, textAlign: "right", position: "sticky", top: "30px" }} colSpan={1}>{item?.ServiceTaxAmount}</TableCell>}
                                <TableCell className="userWiseReportSubHeading" style={{ backgroundColor: tableHeaderColor?.isSubHeadingColor, fontWeight: 700, color: tableHeaderColor.textColor, textAlign: "right", position: "sticky", top: "30px" }} colSpan={1}>{item?.Valuation}</TableCell>
                                <TableCell className="userWiseReportSubHeading" style={{ backgroundColor: tableHeaderColor?.isSubHeadingColor, fontWeight: 700, color: tableHeaderColor.textColor, textAlign: "right", position: "sticky", top: "30px" }} colSpan={1}>{item?.NetAmount} </TableCell>
                            </> :
                            item?.isTotal ?
                                <>
                                    <TableCell className="userWiseReportSubTotal" colSpan={2} style={{ backgroundColor: tableHeaderColor?.isTotalColor,height:"36px" }}>{item?.SN}</TableCell>
                                    <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: "right", backgroundColor: tableHeaderColor?.isTotalColor,height:"36px" }}>{item?.NOP}</TableCell>
                                    <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: "right", backgroundColor: tableHeaderColor?.isTotalColor,height:"36px" }}>{item?.Freight}</TableCell>
                                    <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: "right", backgroundColor: tableHeaderColor?.isTotalColor,height:"36px" }}>{item?.CartageAmt}</TableCell>
                                    <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: "right", backgroundColor: tableHeaderColor?.isTotalColor,height:"36px" }}>{item?.HamaliChgs}</TableCell>
                                    <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: "right", backgroundColor: tableHeaderColor?.isTotalColor,height:"36px" }}>{item?.OtherChgs}</TableCell>
                                    {loginCountryId!==2&& <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: "right", backgroundColor: tableHeaderColor?.isTotalColor,height:"36px" }}>{item?.ServiceTaxAmount}</TableCell>}
                                    <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: "right", backgroundColor: tableHeaderColor?.isTotalColor,height:"36px" }}>{item?.Valuation}</TableCell>
                                    <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: "right", backgroundColor: tableHeaderColor?.isTotalColor,height:"36px" }}>{item?.NetAmount}</TableCell>
                                </>
                                :
                                <>
                                    <TableCell className="userwiseTD" style={{ fontSize: "12px", textAlign: "center", }} colSpan={1}>{item?.SN}</TableCell>
                                    <TableCell className="userwiseTD" style={{ fontSize: "12px", }} colSpan={1}><span className='status' style={{ backgroundColor: colors[item.PaymentTypeID], display: "inline-block", paddingLeft: "10px", paddingRight: "10px" }}>{item.PaymentType}</span></TableCell>
                                    <TableCell className="userwiseTD" style={{ fontSize: "12px", textAlign: "right", }} colSpan={1}>{item?.NOP}</TableCell>
                                    <TableCell className="userwiseTD" style={{ fontSize: "12px", textAlign: "right", }} colSpan={1}>{item?.Freight}</TableCell>
                                    <TableCell className="userwiseTD" style={{ fontSize: "12px", textAlign: "right", }} colSpan={1}>{item?.CartageAmt}</TableCell>
                                    <TableCell className="userwiseTD" style={{ fontSize: "12px", textAlign: "right", }} colSpan={1}>{item?.HamaliChgs}</TableCell>
                                    <TableCell className="userwiseTD" style={{ fontSize: "12px", textAlign: "right", }} colSpan={1}>{item?.OtherChgs}</TableCell>
                                    {loginCountryId!==2&&<TableCell className="userwiseTD" style={{ fontSize: "12px", textAlign: "right", }} colSpan={1}>{item?.ServiceTaxAmount}</TableCell>}
                                    <TableCell className="userwiseTD" style={{ fontSize: "12px", textAlign: "right", }} colSpan={1}>{item?.Valuation}</TableCell>
                                    <TableCell className="userwiseTD" style={{ fontSize: "12px", textAlign: "right", }} colSpan={1}>{item?.NetAmount} </TableCell>
                                </>
                }
            </TableRow>
        )
    }
    const InsideRowContentForExcel = ({ item, index }) => {
        return (
            <TableRow className="receivedTr" key={index}>
                {
                    item?.isHeading ?
                        <>
                            <TableCell className="userWiseReportHeading" key={index} style={{ color: tableHeaderColor.textColor, fontSize: "20px",backgroundColor: tableHeaderColor?.isHeadingColor }} colSpan={4}>{item?.SN}</TableCell>
                            <TableCell className="userWiseReportHeading" key={index} style={{ textAlign: "right", color: tableHeaderColor.textColor, fontSize: "20px",backgroundColor: tableHeaderColor?.isHeadingColor }} colSpan={4}>{item?.CartageAmt}</TableCell>
                            <TableCell className="userWiseReportHeading" style={{ textAlign: "right", color: tableHeaderColor.textColor, fontSize: "20px",backgroundColor: tableHeaderColor?.isHeadingColor }} colSpan={loginCountryId===2?4:6}>{item?.Valuation} </TableCell>
                        </> :
                        item?.isSubHeading ?
                            <>
                                <TableCell className="userWiseReportSubHeading" style={{ backgroundColor: tableHeaderColor?.isSubHeadingColor, fontSize:"20px", color: tableHeaderColor.textColor, textAlign: "center",  }} colSpan={1}>{item?.SN}</TableCell>
                                <TableCell className="userWiseReportSubHeading" style={{ backgroundColor: tableHeaderColor?.isSubHeadingColor, fontSize:"20px", color: tableHeaderColor.textColor,  }} colSpan={2}>{item?.PaymentType}</TableCell>
                                <TableCell className="userWiseReportSubHeading" style={{ backgroundColor: tableHeaderColor?.isSubHeadingColor, fontSize:"20px", color: tableHeaderColor.textColor, textAlign: "right",  }} colSpan={1}>{item?.NOP}</TableCell>
                                <TableCell className="userWiseReportSubHeading" style={{ backgroundColor: tableHeaderColor?.isSubHeadingColor, fontSize:"20px", color: tableHeaderColor.textColor, textAlign: "right",  }} colSpan={1}>{item?.Freight}</TableCell>
                                <TableCell className="userWiseReportSubHeading" style={{ backgroundColor: tableHeaderColor?.isSubHeadingColor, fontSize:"20px", color: tableHeaderColor.textColor, textAlign: "right",  }} colSpan={1}>{item?.CartageAmt}</TableCell>
                                <TableCell className="userWiseReportSubHeading" style={{ backgroundColor: tableHeaderColor?.isSubHeadingColor, fontSize:"20px", color: tableHeaderColor.textColor, textAlign: "right",  }} colSpan={1}>{item?.HamaliChgs}</TableCell>
                                <TableCell className="userWiseReportSubHeading" style={{ backgroundColor: tableHeaderColor?.isSubHeadingColor, fontSize:"20px", color: tableHeaderColor.textColor, textAlign: "right",  }} colSpan={1}>{item?.OtherChgs}</TableCell>
                                {loginCountryId!==2&&<TableCell className="userWiseReportSubHeading" style={{ backgroundColor: tableHeaderColor?.isSubHeadingColor, fontSize:"20px", color: tableHeaderColor.textColor, textAlign: "right",  }} colSpan={2}>{item?.ServiceTaxAmount}</TableCell>}
                                <TableCell className="userWiseReportSubHeading" style={{ backgroundColor: tableHeaderColor?.isSubHeadingColor, fontSize:"20px", color: tableHeaderColor.textColor, textAlign: "right",  }} colSpan={2}>{item?.Valuation}</TableCell>
                                <TableCell className="userWiseReportSubHeading" style={{ backgroundColor: tableHeaderColor?.isSubHeadingColor, fontSize:"20px", color: tableHeaderColor.textColor, textAlign: "right",  }} colSpan={2}>{item?.NetAmount} </TableCell>
                            </> :
                            item?.isTotal ?
                                <>
                                    <TableCell className="userWiseReportSubTotal" colSpan={3} style={{ fontWeight:"700",fontSize: "20px",backgroundColor: tableHeaderColor?.isTotalColor,height:"36px" }}>{item?.SN}</TableCell>
                                    <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: "right", fontWeight:"700",fontSize: "20px",backgroundColor: tableHeaderColor?.isTotalColor,height:"36px" }}>{item?.NOP}</TableCell>
                                    <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: "right", fontWeight:"700",fontSize: "20px",backgroundColor: tableHeaderColor?.isTotalColor,height:"36px" }}>{item?.Freight}</TableCell>
                                    <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: "right", fontWeight:"700",fontSize: "20px",backgroundColor: tableHeaderColor?.isTotalColor,height:"36px" }}>{item?.CartageAmt}</TableCell>
                                    <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: "right", fontWeight:"700",fontSize: "20px",backgroundColor: tableHeaderColor?.isTotalColor,height:"36px" }}>{item?.HamaliChgs}</TableCell>
                                    <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: "right", fontWeight:"700",fontSize: "20px",backgroundColor: tableHeaderColor?.isTotalColor,height:"36px" }}>{item?.OtherChgs}</TableCell>
                                    {loginCountryId!==2&&<TableCell className="userWiseReportSubTotal" colSpan={2} style={{ textAlign: "right", fontWeight:"700",fontSize: "20px",backgroundColor: tableHeaderColor?.isTotalColor,height:"36px" }}>{item?.ServiceTaxAmount}</TableCell>}
                                    <TableCell className="userWiseReportSubTotal" colSpan={2} style={{ textAlign: "right", fontWeight:"700",fontSize: "20px",backgroundColor: tableHeaderColor?.isTotalColor,height:"36px" }}>{item?.Valuation}</TableCell>
                                   <TableCell className="userWiseReportSubTotal" colSpan={2} style={{ textAlign: "right", fontWeight:"700",fontSize: "20px", backgroundColor: tableHeaderColor?.isTotalColor,height:"36px" }}>{item?.NetAmount}</TableCell>
                                </>
                                :
                                <>
                                    <TableCell className="userwiseTD" style={{ fontSize: "20px", textAlign: "center", }} colSpan={1}>{item?.SN}</TableCell>
                                    <TableCell className="userwiseTD" style={{ fontSize: "20px", }} colSpan={2}><span className='status' style={{ backgroundColor: colors[item.PaymentTypeID], display: "inline-block", paddingLeft: "10px", paddingRight: "10px" }}>{item.PaymentType}</span></TableCell>
                                    <TableCell className="userwiseTD" style={{ fontSize: "20px", textAlign: "right", }} colSpan={1}>{item?.NOP}</TableCell>
                                    <TableCell className="userwiseTD" style={{ fontSize: "20px", textAlign: "right", }} colSpan={1}>{item?.Freight}</TableCell>
                                    <TableCell className="userwiseTD" style={{ fontSize: "20px", textAlign: "right", }} colSpan={1}>{item?.CartageAmt}</TableCell>
                                    <TableCell className="userwiseTD" style={{ fontSize: "20px", textAlign: "right", }} colSpan={1}>{item?.HamaliChgs}</TableCell>
                                    <TableCell className="userwiseTD" style={{ fontSize: "20px", textAlign: "right", }} colSpan={1}>{item?.OtherChgs}</TableCell>
                                    {loginCountryId!==2&&<TableCell className="userwiseTD" style={{ fontSize: "20px", textAlign: "right", }} colSpan={2}>{item?.ServiceTaxAmount}</TableCell>}
                                    <TableCell className="userwiseTD" style={{ fontSize: "20px", textAlign: "right", }} colSpan={2}>{item?.Valuation}</TableCell>
                                    <TableCell className="userwiseTD" style={{ fontSize: "20px", textAlign: "right", }} colSpan={2}>{item?.NetAmount} </TableCell>
                                </>
                }
            </TableRow>
        )
    }
    return (
        <>
            <Stack style={{ margin: "0px 10px",marginRight:'0px' }}>
                <Item className='userReport'>
                    <Item className='userReport-heading'>
                        Received Report
                    </Item>
                    <Item className='userReport-buttons'>
                        {searchResult ? <>
                            {disableExcel ?
                                <Box>
                                    <Button variant="outlined" className="userWisereporttembtn" disabled={true}>Export to Excel</Button>
                                </Box>
                                :
                                <Box onKeyDown={(e)=>navigation3(e,"ExportToPdf",id.reportmainButton,()=>{})}>
                                    <ReactHtmlTableToExcel
                                        id="ExportToExl"
                                        className="userWisereporttemExcelBtn"
                                        table="table-recvPaymentWiseSummaryReport-xls"
                                        filename={`Received Report ${currentDateTime}`}
                                        sheet="tablexls"
                                        buttonText="Export to Excel"
                                    />
                                </Box>}

                            <Box>
                                <Button variant="outlined" className="userWisereporttembtn" id="ExportToPdf"
                                    onClick={() => {
                                        setSearchResult(false);
                                        // if (showTableData?.length > 200) {
                                        //     setLargePDF(true)
                                        // } else {
                                        //     printClick(true)
                                        // }
                                        printClick(true)
                                    }}
                                    onKeyDown={(e)=>navigation3(e,"PrintBtn",disableExcel?id.reportmainButton:"ExportToExl",() => {setSearchResult(false);printClick(true)})}
                                >
                                    Export to Pdf
                                </Button>
                            </Box>
                            <Box>
                                <Button
                                    variant="outlined" id="PrintBtn"
                                    className="userWisereporttembtn"
                                    onClick={() => {
                                        setSearchResult(false);
                                        // if (showTableData?.length > 200) {
                                        //     setLargePDF(true)
                                        // } else {
                                        //     printClick(false)
                                        // }
                                        printClick(false)
                                    }}
                                    onKeyDown={(e)=>navigation3(e,id.fromDate,"ExportToPdf",() => {setSearchResult(true);printClick(false)})}
                                >
                                    Print
                                </Button>
                            </Box>
                        </> : <>
                            <Box>
                                <Button 
                                    variant="outlined" id="backBtn"
                                    className="userWisereporttembtn"
                                    onClick={() => { setSearchResult(true); setLargePDF(false) }}
                                    onKeyDown={(e)=>navigation3(e,id.fromDate,id.reportmainButton,() => {setSearchResult(true);setLargePDF(false);focusElemnt(id.reportmainButton)})}
                                >
                                    Back
                                </Button>
                            </Box>
                        </>}

                    </Item>
                </Item>
            </Stack>
            {
                searchResult ?
                    <Stack sx={{ marginLeft: 2, marginRight: 2, height: 470 }} className="scroll">
                        <TableContainer className="lr-popup-table lrModel " component={Paper} style={{borderRadius:"6px"}}>
                            <Table  size="small" aria-label="a dense table">
                                {showTableData?.length < 1 ? (
                                    <>
                                        <TableHead>
                                            <TableCell className="userWiseReportHeading"  style={{ textAlign: "left", color: tableHeaderColor.textColor, backgroundColor: tableHeaderColor?.isHeadingColor, position: "sticky", top: "-5px" }} colSpan={3}>Transaction: Received By CRS DeskApp</TableCell>
                                            <TableCell className="userWiseReportHeading"  style={{ textAlign: "left", color: tableHeaderColor.textColor, backgroundColor: tableHeaderColor?.isHeadingColor,  position: "sticky", top: "-5px" }} colSpan={2}>{`Source City: ${headerData.selSourceCity}`}</TableCell>
                                            <TableCell className="userWiseReportHeading" style={{ textAlign: "left", color: tableHeaderColor.textColor, backgroundColor: tableHeaderColor?.isHeadingColor,  position: "sticky", top: "-5px" }} colSpan={loginCountryId===2?3:4}>{`Received City: ${headerData.selReceivedCity}`} </TableCell>
                                            <TableCell className="userWiseReportHeading" style={{  color: tableHeaderColor.textColor, backgroundColor: tableHeaderColor?.isHeadingColor, position: "sticky", top: "-5px" }} colSpan={1}></TableCell>
                                        </TableHead>
                                        <TableBody>
                                            <TableRow>
                                                <TableCell colSpan={10}>
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            justifyContent: 'center',
                                                            marginTop: '20px',
                                                            marginBottom: '20px',
                                                            color: 'red',
                                                            fontSize: '14px',
                                                        }}
                                                    >
                                                        <span>No results found. Please refine your search parameters and search again.</span>
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </>
                                ) : showTableData.length > 1 ? (
                                    <TableBody className="filter-data-row" style={{ border: "none" }}>
                                        {showTableData?.map((item, index) => (
                                            <InsideRowContent item={item} index={index} key={index} />
                                        ))}
                                    </TableBody>
                                ) : (
                                    ''
                                )}
                            </Table>
                            <Table id="table-recvPaymentWiseSummaryReport-xls" size="small" aria-label="a dense table" style={{display:"none"}}>
                                <TableHead style={{fontWeight: 'bold' }}>
                                    <TableRow>
                                        <TableCell className="reportTD" style={{ fontSize: '24px', fontWeight: '500', textAlign: 'left' }} colSpan={7}>
                                            <h3 style={{ paddingLeft: '17px' }}>Report For: Received Reports</h3>
                                        </TableCell>
                                        <TableCell className="reportTD" style={{ fontSize: '24px', fontWeight: '500', textAlign: 'left' }} colSpan={7}>
                                            <h3 style={{ paddingLeft: '17px' }}>Company Name : {loginData?.strCompanyName}</h3>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell colSpan={14}></TableCell>
                                    </TableRow>
                                    <TableRow style={{ color: 'white' }}>
                                        {excelHeader1?.map((item, i) =>
                                            <TableCell
                                                className="ReportItemHead"
                                                style={{ backgroundColor: '#e5f3ff', color:"#444444", fontSize: '20px', fontWeight: '600', textAlign: 'left' }}
                                                colSpan={item.col}
                                                key={i}
                                            >
                                                {item.value}
                                            </TableCell>
                                        )}
                                    </TableRow>
                                    <TableRow>
                                        <TableCell
                                            className="reportTD"
                                            style={{ fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                                            colSpan={2}
                                        >
                                            <span>{headerData.company}</span>
                                        </TableCell>
                                        <TableCell
                                            className="reportTD"
                                            style={{ fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                                            colSpan={2}
                                        >
                                            <span>{headerData.fromDate}</span>
                                        </TableCell>
                                        <TableCell
                                            className="reportTD"
                                            style={{ fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                                            colSpan={2}
                                        >
                                            <span>{headerData.toDate}</span>
                                        </TableCell>
                                        <TableCell
                                            className="reportTD"
                                            style={{ fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                                            colSpan={2}
                                        >
                                            <span>{headerData.selSourceCity}</span>
                                        </TableCell>
                                        <TableCell
                                            className="reportTD"
                                            style={{ fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                                            colSpan={2}
                                        >
                                            <span>{headerData?.selSourceBranch}</span>
                                        </TableCell>
                                        <TableCell
                                            className="reportTD"
                                            style={{ fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                                            colSpan={2}
                                        >
                                            <span>{headerData?.selReceivedCity}</span>
                                        </TableCell>
                                        <TableCell
                                            className="reportTD"
                                            style={{ fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                                            colSpan={2}
                                        >
                                            <span>{headerData?.selReceivedBranch}</span>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow style={{ color: 'white' }}>
                                        {excelHeader2?.map((item, i) =>
                                            <TableCell
                                                className="ReportItemHead"
                                                style={{ backgroundColor: '#e5f3ff', color:"#444444", fontSize: '20px', fontWeight: '600', textAlign: 'left' }}
                                                colSpan={item.col}
                                                key={i}
                                            >
                                                {item.value}
                                            </TableCell>
                                        )}
                                    </TableRow>
                                    <TableRow>
                                        <TableCell
                                            className="reportTD"
                                            style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                                            colSpan={2}
                                        >
                                            <span>{headerData?.paymentType}</span>
                                        </TableCell>
                                        <TableCell
                                            className="reportTD"
                                            style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                                            colSpan={2}
                                        >
                                            <span>{headerData?.bookingType} </span>
                                        </TableCell>
                                        <TableCell
                                            className="reportTD"
                                            style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                                            colSpan={2}
                                        >
                                            <span>{headerData?.receiveType} </span>
                                        </TableCell>
                                        <TableCell
                                            className="reportTD"
                                            style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                                            colSpan={2}
                                        >
                                            <span>{headerData?.reportView}</span>
                                        </TableCell>
                                        <TableCell
                                            className="reportTD"
                                            style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                                            colSpan={2}
                                        >
                                            <span>{headerData?.reportOptions} </span>
                                        </TableCell>
                                        <TableCell
                                            className="reportTD"
                                            style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                                            colSpan={2}
                                        >
                                            <span>{headerData?.showOnlyAutoRec} </span>
                                        </TableCell>
                                        <TableCell
                                            className="reportTD"
                                            style={{ fontWeight: 'bold', fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                                            colSpan={2}
                                        >
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell colSpan={14}></TableCell>
                                    </TableRow>
                                </TableHead>
                                {showTableData?.length < 1 ? (
                                    <>
                                        <TableHead>
                                            <TableCell className="userWiseReportHeading" style={{ textAlign: "left", color: tableHeaderColor.textColor, backgroundColor: tableHeaderColor?.isHeadingColor, position: "sticky", top: "-5px" }} colSpan={4}>Transaction: Received By CRS DeskApp</TableCell>
                                            <TableCell className="userWiseReportHeading" style={{ textAlign: "left", color: tableHeaderColor.textColor, backgroundColor: tableHeaderColor?.isHeadingColor, position: "sticky", top: "-5px" }} colSpan={4}>{`Source City: ${headerData.selSourceCity}`}</TableCell>
                                            <TableCell className="userWiseReportHeading" style={{ textAlign: "left", color: tableHeaderColor.textColor, backgroundColor: tableHeaderColor?.isHeadingColor, position: "sticky", top: "-5px" }} colSpan={loginCountryId===2?3:4}>{`Received City: ${headerData.selReceivedCity}`} </TableCell>
                                            <TableCell className="userWiseReportHeading" style={{ color: tableHeaderColor.textColor, backgroundColor: tableHeaderColor?.isHeadingColor, position: "sticky", top: "-5px" }} colSpan={1}></TableCell>
                                        </TableHead>
                                        <TableBody>
                                            <TableRow>
                                                <TableCell colSpan={14}>
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            justifyContent: 'center',
                                                            marginTop: '20px',
                                                            marginBottom: '20px',
                                                            color: 'red',
                                                            fontSize: '14px',
                                                        }}
                                                    >
                                                        <span>No results found. Please refine your search parameters and search again.</span>
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </>
                                ) : showTableData.length > 1 ? (
                                    <TableBody className="filter-data-row" style={{ border: "none" }}>
                                        {showTableData?.map((item, index) => (
                                            <InsideRowContentForExcel item={item} index={index} key={index} />
                                        ))}
                                    </TableBody>
                                ) : (
                                    ''
                                )}
                            </Table>
                        </TableContainer>
                    </Stack>
                    : largePDF ? <PaymentWiseLargePdf headerData={headerData} data={showTableData} tableHeader={paymentWiseColumns} /> :
                    // :
                    <>
                    
                        {generatePDF ? <div className={'generatePDF'}>Generating PDF....</div> : ''}
                        {load ? (
                            <object
                                id="recvedPaymentWiseOutput"
                                type="application/pdf"
                                width={"100%"}
                                height="440"
                                title="MTLPL -Cargo System - After Transfer Summary Report"
                                aria-label="MTLPL -Cargo System - After Transfer Summary Report"
                            ></object>
                        ) : (
                            ''
                        )}
                    </>
            }

        </>
    )
}

export default PaymentTypeAndSourceTable